import { forwardRef, type ReactNode, type KeyboardEvent } from 'react'
import { cn } from '../utils/cn.ts'

export interface PaymentMethodRadioProps {
  selected: boolean
  disabled?: boolean
  icon: ReactNode
  label: string
  onChange: () => void
  className?: string
}

export const PaymentMethodRadio = forwardRef<HTMLDivElement, PaymentMethodRadioProps>(
  function PaymentMethodRadio({ selected, disabled = false, icon, label, onChange, className }, ref) {
    function handleClick() {
      if (!disabled) {
        onChange()
      }
    }

    function handleKeyDown(e: KeyboardEvent<HTMLDivElement>) {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault()
        if (!disabled) {
          onChange()
        }
      }
    }

    return (
      <div
        ref={ref}
        role="radio"
        aria-checked={selected}
        aria-disabled={disabled || undefined}
        tabIndex={0}
        className={cn(
          'payment-radio',
          selected && 'payment-radio-selected',
          disabled && 'payment-radio-disabled',
          className,
        )}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        <div className="payment-radio-circle">
          {selected && <div className="payment-radio-dot" />}
        </div>
        <div className="payment-radio-icon">{icon}</div>
        <span className="payment-radio-label">{label}</span>
      </div>
    )
  },
)
